// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_l8-0";
export var fileCarousel = "_l8-2";
export var removeFileButton = "_l8-1";